<div class="top-m8" *transloco="let t; read: 'term-and-policy-pages.accessibility-statement'">

    <!-- HEADER -->
    <div class="form-menu-container">
        <ng-container [ngTemplateOutlet]="stickyHeader"></ng-container>
    </div>

    <div class="form-menu-container sticky" *ngIf="isSticky()">
        <ng-container [ngTemplateOutlet]="stickyHeader"></ng-container>
    </div>

    <ng-template #stickyHeader>
        <div class="form-menu">
            <div class="form-menu-actions">
                <button type="submit" class="btn btn-primary" (click)="goToHome()">
                    <i class="fa fa-arrow-left"></i>&nbsp;
                        {{ t('back') }}
                    <i class="fa fa-home"></i>&nbsp;
                </button>
            </div>
            <div class="form-menu-info">
                <i class="fa fa-user"></i>&nbsp;
                {{ t('header-title') }}
            </div>
            <div class="span"></div>
        </div>
    </ng-template>


    <!-- CONTENT  -->
    <div class="container">

        <!-- mandatory-content-requirements -->
        <div class="block">
            <h3><b>{{ t('mandatory-content-requirements-title') }}</b></h3>
            <p [innerHtml]="t('mandatory-content-requirements')"></p>
        </div>

        <!-- compliance-status -->
        <div class="block">
            <h3><b>{{ t('compliance-status-title') }}</b></h3>
            <p [innerHtml]="t('compliance-status')"></p>
        </div>

        <!-- setup-date -->
        <div class="block">
            <h3><b>{{ t('setup-date-title') }}</b></h3>
            <p [innerHtml]="t('setup-date')"></p>
        </div>

        <!-- feedback-and-contact-details -->
        <div class="block">
            <h3><b>{{ t('feedback-and-contact-details-title') }}</b></h3>
            <p [innerHtml]="t('feedback-and-contact-details')"></p>
        </div>

        <!-- enforcement-procedures -->
        <div class="block">
            <h3><b>{{ t('enforcement-procedures-title') }}</b></h3>
            <p [innerHtml]="t('enforcement-procedures')"></p>
        </div>

        <!-- improvement-plan -->
        <div class="block">
            <h3><b>{{ t('improvement-plan-title') }}</b></h3>
            <p [innerHtml]="t('improvement-plan')"></p>
        </div>

        <br><br><br>

    </div>

</div>
